import type { AxiosInstance } from 'axios';
import type { Language } from './language.types';

export const languageQuery = async (
	axiosCmsInstance: AxiosInstance,
	cmsPath: string
): Promise<Language[]> => {
	const { data } = await axiosCmsInstance.get(cmsPath + '/languages.json');
	return data.data;
};
